<template>
    <el-dropdown trigger="click">
        <span class="el-dropdown-link">
            <div v-if="!SipType">
                <i class="iconfont iconzaixian fxn-text-green" v-if="SipStatus.status == '签入'"></i>
                <i class="iconfont iconlixian fxn-text-gray" v-if="SipStatus.status == '签出'"></i>
                <i class="iconfont iconmangzhi fxn-text-red" v-if="SipStatus.status == '置忙'"></i>
                <i class="iconfont iconxianzhi fxn-text-yellow" v-if="SipStatus.status == '置闲'"></i>
                {{SipStatus.status}}<i class="el-icon-arrow-down el-icon--right"></i>
            </div>
            <div v-else>
                <el-button type="primary">
                    <i class="iconfont iconzaixian fxn-text-green" v-if="SipStatus.status == '签入'"></i>
                    <i class="iconfont iconlixian fxn-text-gray" v-if="SipStatus.status == '签出'"></i>
                    <i class="iconfont iconzaixian fxn-text-red" v-if="SipStatus.status == '置忙'"></i>
                    <i class="iconfont iconzaixian fxn-text-yellow" v-if="SipStatus.status == '置闲'"></i>
                    {{SipStatus.status}}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
            </div>            
        </span>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="fxn-text-green" icon=" iconfont iconzaixian" @click.native="updateStatus(1)">签入</el-dropdown-item>
            <el-dropdown-item class="fxn-text-gray" icon=" iconfont iconlixian" @click.native="updateStatus(2)">签出</el-dropdown-item>
            <el-dropdown-item class="fxn-text-red" icon=" iconfont iconmangzhi" @click.native="updateStatus(3)">置忙</el-dropdown-item>
            <el-dropdown-item class="fxn-text-yellow" icon=" iconfont iconxianzhi" @click.native="updateStatus(4)">置闲</el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
    let ws = '';
    export default {
        props: {
            SipStatus: {
                type: Object
            },
            SipType: {
                type: Boolean
            },
        },
        computed: {
            isseatcalling() {
                return this.$store.getters.isseatcalling
            }
        },
        watch: {
            isseatcalling(val, oldval) {
                if (val) { //当坐席拨打 置忙预测式外呼坐席
                    let arr = ['', '签入', '签出', '置忙', '置闲'];
                    this.oldStatus = arr.indexOf(this.SipStatus.status);
                    this.post('/ycapi/agent/agent_status_update',{
                        type: 3
                    }).then(res => {})
                } else {
                    if (oldval !== null) {
                        let arr = ['', '签入', '签出', '置忙', '置闲'];
                        let status = arr.indexOf(this.SipStatus.status)
                        this.post('/ycapi/agent/agent_status_update',{
                            type: status === -1 ? this.oldStatus :  status
                        }).then(res => {})
                    }
                    
                }
            }
        },
        data(){
            return{
                oldStatus: '',
            }
        },
        methods:{
            //修改坐席状态
            updateStatus(type){
                this.post('/ycapi/agent/agent_status_update',{
                    type: type
                })
                .then(res=> {
                    let{ msg, code, data } = res.data
                    if( code !== 1 ){
                        if( code == 1002 ){
                            this.$message({
                                message: msg,
                                type: 'warning'
                            });
                        }else{
                            this.$message({
                                message: msg,
                                type: 'error'
                            });
                        }
                        return false;
                    }else{
                        this.$message({
                            message: '操作成功!',
                            type: 'success'
                        });
                    }
                })
            },

            
        },
        mounted(){
            
        }
    }
</script>

<style scoped>
    .fxn-radius{
        width: .5rem;
        height: .5rem;
        border-radius: 50%;
        display: inline-block;
    }
</style>


// WEBPACK FOOTER //
// src/components/AiSip/CallStatus.vue